import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Icon} from '@drivesally/sally-ui';
import {grey} from '@drivesally/sally-ui/lib/libs/colors';

import ChatMessage from '../../../chaya/components/ChatMessage/ChatMessage';
import GroupRow from '../../../chaya/components/Conversation/components/GroupRow';
import LoadingContainer from '../../../chaya/components/Conversation/components/LoadingContainer';

const Panel = styled.div`
  background: ${grey};
  border-radius: 4px;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

const MessageList = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;

  &::-webkit-scrollbar {
    display: block;
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    display: block;
  }
`;

const EmptyState = styled.div`
  align-items: center;
  color: #666;
  display: flex;
  flex: 1;
  font-size: 14px;
  justify-content: center;
  padding: 20px;
`;

const CrmTicketConversationPanel = ({emptyMessage, loading, messages}) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) bottomRef.current.scrollIntoView();
  }, [messages]);

  return (
    <Panel>
      <MessageList>
        {loading ? (
          <LoadingContainer full>
            <Icon icon="loading2" spin />
          </LoadingContainer>
        ) : !messages.length ? (
          <EmptyState>{emptyMessage || 'No messages found'}</EmptyState>
        ) : (
          messages.map((message) => (
            <GroupRow key={message.id}>
              <ChatMessage
                agent={message.agent}
                author={message.author}
                date={message.created_at}
                driverReadAt={message.driver_read_at}
                message={message.text}
                type={message.type}
              />
            </GroupRow>
          ))
        )}
        <div ref={bottomRef} />
      </MessageList>
    </Panel>
  );
};

CrmTicketConversationPanel.propTypes = {
  emptyMessage: PropTypes.string,
  loading: PropTypes.bool,
  messages: PropTypes.array,
};

export default React.memo(CrmTicketConversationPanel);
